export default "__VITE_ASSET__BF2yKmZj__"